/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// Shrink header on scroll
(function () {
  function update() {
    document.body.classList.toggle('scrolled', window.scrollY > 30);
  }
  update(); // set initial state
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('load', update);
})();
// Split-colour wordmark (text logo only)
(function(){
  var el = document.querySelector('[data-section-type="header"] .header__logo-link, [data-section-type="header"] .header__title a, [data-section-type="header"] .logo a');
  if(!el) return;
  // If an <img> is inside, a logo image is in use—do nothing
  if (el.querySelector('img')) return;

  var txt = (el.textContent || '').trim();
  if(!txt) return;
  var parts = txt.split(/\s+/);
  var first = parts[0];
  var rest  = parts.slice(1).join(' ');
  el.innerHTML = '<span class="te-wordmark" aria-label="'+txt.replace(/"/g,'&quot;')+'">' +
                   '<span class="te-wordmark__first">'+first+'</span>' +
                   (rest ? ' <span class="te-wordmark__second">'+rest+'</span>' : '') +
                 '</span>';
})();

// Next Working Day delivery (1pm cutoff), skips weekends, optional bank holidays
(function(){
  function isBizDay(d, holidays){
    var day = d.getDay(); // 0 Sun, 6 Sat
    if (day === 0 || day === 6) return false;
    var iso = d.toISOString().slice(0,10);
    return !holidays.has(iso);
  }
  function nextBizDay(d, holidays){
    var t = new Date(d);
    t.setDate(t.getDate() + 1);
    while (!isBizDay(t, holidays)) t.setDate(t.getDate() + 1);
    return t;
  }
  function fmtUK(d){
    var w = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    var m = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return w[d.getDay()] + ', ' + d.getDate() + ' ' + m[d.getMonth()];
  }

  document.querySelectorAll('.te-nextday').forEach(function(box){
    var cutoff  = parseInt(box.dataset.cutoffHour || '13', 10); // 13:00
    var holidays = new Set((box.dataset.holidays || '').split(',').filter(Boolean));
    var timer;

    function compute(){
      var now = new Date();

      // Determine dispatch day:
      // - If today is a business day and before cutoff => dispatch today
      // - Otherwise => next business day
      var dispatch = new Date(now);
      var beforeCutoff = (now.getHours() < cutoff) || (now.getHours() === cutoff && now.getMinutes() === 0 && now.getSeconds() === 0);

      if (!isBizDay(dispatch, holidays) || !beforeCutoff) {
        // after cutoff OR weekend/holiday -> next business day
        if (isBizDay(dispatch, holidays) && !beforeCutoff) {
          dispatch = nextBizDay(dispatch, holidays);
        } else {
          // weekend/holiday today -> find the next biz day from today
          while (!isBizDay(dispatch, holidays)) dispatch.setDate(dispatch.getDate() + 1);
        }
      }
      // Delivery = next business day after dispatch
      var delivery = nextBizDay(dispatch, holidays);

      // Update date text
      var dateEl = box.querySelector('.te-nextday__date');
      if (dateEl) dateEl.textContent = fmtUK(delivery);

      // Target cutoff for countdown:
      // - If today is business day and before cutoff -> today 13:00
      // - Else -> next business day's 13:00
      var target = new Date(now);
      if (isBizDay(now, holidays) && beforeCutoff) {
        target.setHours(cutoff, 0, 0, 0);
      } else {
        var nb = new Date(now);
        while (!isBizDay(nb, holidays)) nb.setDate(nb.getDate() + 1);
        // If we reached a biz day but it's still after cutoff (e.g., we were after cutoff today),
        // go to the *next* biz day for the target cutoff
        if (!beforeCutoff || !isBizDay(now, holidays)) {
          // We already picked the next biz day; ensure it's indeed the "next" for the target
          // (nb is already next biz day from now)
        }
        nb.setHours(cutoff, 0, 0, 0);
        target = nb;
      }

      if (timer) clearInterval(timer);
      function tick(){
        var now = new Date();
        var diff = target - now;
        if (diff <= 0){
          clearInterval(timer);
          compute(); // cutoff passed; recompute dates/next target
          return;
        }
        var s = Math.floor(diff / 1000);
        var h = Math.floor(s / 3600); s -= h*3600;
        var m = Math.floor(s / 60);   s -= m*60;
        var out =
          h + ' Hrs ' +
          (m < 10 ? '0' : '') + m + ' Mins ' +
          (s < 10 ? '0' : '') + s + ' Secs';
        var c = box.querySelector('.te-nextday__count');
        if (c) c.textContent = out;
      }
      tick();
      timer = setInterval(tick, 1000);
    }

    compute();

    // Hide if the selected variant becomes unavailable (best-effort for Warehouse)
    document.documentElement.addEventListener('variant:changed', function(e){
      var v = e.detail && e.detail.variant;
      if (!box) return;
      box.style.display = (v && v.available === false) ? 'none' : '';
    });
  });
})();

// ===== TE Neck cover upsell (cart drawer + cart page) =====
// Offer markup comes from snippets/te-neck-cover-upsell.liquid, rendered via
// sections/te-neck-cover-upsell.liquid. This script places it under the cart
// line items, handles the Add button, and re-fetches it after cart changes.
(function () {
  if (window.__teNeckUpsell) return;
  window.__teNeckUpsell = true;

  var SECTION = 'te-neck-cover-upsell';
  var timer = null;

  function blockFor(host) { return document.querySelector('[data-te-neck-upsell="' + host + '"]'); }

  function place() {
    var miniList = document.querySelector('#mini-cart .mini-cart__line-item-list');
    var pageTable = document.querySelector('[data-section-type="cart"] .line-item-table');
    var pageCard = pageTable ? pageTable.closest('.card') : null;

    if (miniList) {
      var mini = blockFor('mini');
      if (!mini) {
        mini = document.createElement('div');
        mini.setAttribute('data-te-neck-upsell', 'mini');
        var page = blockFor('page');
        if (page) mini.innerHTML = page.innerHTML;
      }
      if (miniList.nextElementSibling !== mini) miniList.insertAdjacentElement('afterend', mini);
    }
    var pageBlock = blockFor('page');
    if (pageCard && pageBlock && pageCard.nextElementSibling !== pageBlock) pageCard.insertAdjacentElement('afterend', pageBlock);
  }

  function refresh() {
    fetch(window.routes.cartUrl + '?sections=' + SECTION, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        if (!json || typeof json[SECTION] !== 'string') return;
        var tmp = document.createElement('div');
        tmp.innerHTML = json[SECTION];
        var fresh = tmp.querySelector('[data-te-neck-upsell]');
        var html = fresh ? fresh.innerHTML : '';
        ['mini', 'page'].forEach(function (host) {
          var b = blockFor(host);
          if (b) b.innerHTML = html;
        });
        place();
      })
      .catch(function () {});
  }

  function scheduleRefresh() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 350);
  }

  // Size dropdown updates the price shown
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-te-neck-size]');
    if (!sel) return;
    var item = sel.closest('[data-te-neck-item]');
    var opt = sel.options[sel.selectedIndex];
    var price = item && item.querySelector('[data-te-neck-price]');
    if (price && opt && opt.dataset.price) price.textContent = opt.dataset.price;
  });

  // Add button
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-te-neck-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    var item = btn.closest('[data-te-neck-item]');
    var sel = item && item.querySelector('[data-te-neck-size]');
    var variantId = sel ? Number(sel.value) : Number(btn.getAttribute('data-te-neck-add'));
    if (!variantId) return;

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _via: 'neck-cover-offer' } }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (document.querySelector('[data-section-type="cart"]')) {
          window.location.reload();
          return;
        }
        document.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: 1 } }));
        scheduleRefresh();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  });

  // Refresh whenever the cart changes: theme hooks + any cart API call
  document.addEventListener('product:added', scheduleRefresh);
  document.addEventListener('cart:refresh', scheduleRefresh);

  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(scheduleRefresh, function () {});
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (/\/cart\/(add|change|update|clear)/.test(String(url))) this.addEventListener('loadend', scheduleRefresh);
    return origOpen.apply(this, arguments);
  };

  // The theme re-renders the drawer; put our block back when it does
  var placeTimer = null;
  new MutationObserver(function () {
    clearTimeout(placeTimer);
    placeTimer = setTimeout(place, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });

  place();
  if (window.theme && window.theme.cartCount > 0) refresh();
})();

// ===== TE attribution: flag the cart when a customer arrives via the size-alternatives panel =====
(function () {
  try {
    if (!/[?&]ref=size-alt(&|$)/.test(window.location.search)) return;
    if (sessionStorage.getItem('teSizeAlt') === '1') return;
    sessionStorage.setItem('teSizeAlt', '1');
    fetch(window.routes.cartUrl + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { size_alt: 'yes' } })
    }).catch(function () {});
  } catch (e) {}
})();

// ===== TE "open live chat" links: <a href="#live-chat"> clicks the Chatty bubble =====
(function () {
  function isVisible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && getComputedStyle(el).visibility !== 'hidden';
  }
  function findLauncher() {
    var selectors = [
      '[id*="chatty" i] button', '[class*="chatty" i] button',
      '[id*="avada" i] button', '[class*="avada" i] button',
      '[id*="chatty" i]', '[class*="chatty" i]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var els = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < els.length; j++) {
        if (isVisible(els[j])) return els[j];
      }
    }
    // Fallback: any fixed-position element hugging the bottom corner (typical chat bubble)
    var all = document.body.querySelectorAll('div, button, a');
    for (var k = 0; k < all.length; k++) {
      var el = all[k];
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' || !isVisible(el)) continue;
      var r = el.getBoundingClientRect();
      if (r.bottom > window.innerHeight - 8 - 120 && r.height < 120 && r.width < 320) {
        return el.querySelector('button') || el;
      }
    }
    return null;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#live-chat"], a[href$="#live-chat"]');
    if (!a) return;
    e.preventDefault();
    var launcher = findLauncher();
    if (launcher) {
      launcher.click();
      return;
    }
    // Widget not present (blocked / not loaded): fall back to email
    window.location.href = 'mailto:info@turnerequestrian.co.uk';
  });
})();

// ===== TE typography: render long dashes (en/em) as short dashes site-wide =====
(function () {
  var re = /[\u2013\u2014]/g;
  var skip = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1 };
  function fixText(t) {
    if (t.nodeValue && re.test(t.nodeValue)) t.nodeValue = t.nodeValue.replace(re, '-');
    re.lastIndex = 0;
  }
  function fix(root) {
    if (!root) return;
    if (root.nodeType === 3) { fixText(root); return; }
    if (root.nodeType !== 1 || skip[root.tagName]) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) { return skip[n.parentNode && n.parentNode.tagName] ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT; }
    });
    var n, list = [];
    while ((n = walker.nextNode())) list.push(n);
    list.forEach(fixText);
  }
  fix(document.body);
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) fix(added[j]);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
